export const NAMESPACE = "SelectDashboardFieldsModal";

export const TABS = {
  ALL: "all",
  REPORTED: "reported"
};
